export default "__VITE_ASSET__B1mbNwGu__"